import axios from 'axios';

// Nucleus API URL for demo requests (separate from main API)
const NUCLEUS_API_URL = process.env.REACT_APP_NUCLEUS_API_URL || 'http://localhost:5000/api';
const INTER_SERVICE_API_KEY = process.env.REACT_APP_INTER_SERVICE_API_KEY || '';

export interface DemoRequestData {
  fullName: string;
  workEmail: string;
  companyName: string;
  phoneNumber?: string;
  numberOfEmployees: string;
  needs?: string;
}

export interface DemoRequestResponse {
  success: boolean;
  message?: string;
  data?: {
    id: number;
    fullName: string;
    workEmail: string;
  };
  error?: {
    message: string;
  };
}

/**
 * Submit a demo request to nucleus-api
 * Uses X-API-Key authentication (not user JWT)
 */
export const submitDemoRequest = async (data: DemoRequestData): Promise<DemoRequestResponse> => {
  console.log('[DemoRequestService] submitDemoRequest called with:', data);
  console.log('[DemoRequestService] API URL:', NUCLEUS_API_URL);
  console.log('[DemoRequestService] API Key present:', !!INTER_SERVICE_API_KEY);

  try {
    console.log('[DemoRequestService] Making POST request to:', `${NUCLEUS_API_URL}/public/demo-requests`);
    const response = await axios.post<DemoRequestResponse>(
      `${NUCLEUS_API_URL}/public/demo-requests`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': INTER_SERVICE_API_KEY,
          'X-Source': 'magnetix-ui'
        },
        timeout: 10000
      }
    );

    console.log('[DemoRequestService] Response received:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[DemoRequestService] Error caught:', error);
    // Handle axios errors
    if (error.response) {
      // Server responded with error
      return {
        success: false,
        error: {
          message: error.response.data?.error?.message || 'Failed to submit demo request'
        }
      };
    } else if (error.request) {
      // Network error
      return {
        success: false,
        error: {
          message: 'Network error. Please check your connection and try again.'
        }
      };
    } else {
      // Other error
      return {
        success: false,
        error: {
          message: 'An unexpected error occurred. Please try again.'
        }
      };
    }
  }
};

export default {
  submitDemoRequest
};
